import React from 'react'
import css from './FullMessageOverlay.module.css'

type FullMessageOverlayProps = {
  fullMessage: string
}

const FullMessageOverlay: React.FC<FullMessageOverlayProps> = ({ fullMessage }) => {
  return (
    <div className={css.fullMessage}>{fullMessage}</div>
  )
}

export default FullMessageOverlay